import { render, staticRenderFns } from "./CustomerHeaderBasic.vue?vue&type=template&id=93d3fb82"
import script from "./CustomerHeaderBasic.vue?vue&type=script&lang=js"
export * from "./CustomerHeaderBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93d3fb82')) {
      api.createRecord('93d3fb82', component.options)
    } else {
      api.reload('93d3fb82', component.options)
    }
    module.hot.accept("./CustomerHeaderBasic.vue?vue&type=template&id=93d3fb82", function () {
      api.rerender('93d3fb82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/partials/CustomerHeaderBasic.vue"
export default component.exports